var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import { Icon } from 'rcm-mobile';
import './style/index.scss';
/**
 * @author sayll
 * @version 0.0.1
 */
export default class Switch extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            value: props.defaultValue || props.value
        };
    }
    render() {
        const { value: checked } = this.state;
        const _a = this.props, { prefixCls, className, loading, checkLabel, unCheckLabel, size, defaultValue, value, color, readOnly, disabled, onBeforeChange, onChange, onClick } = _a, resetProps = __rest(_a, ["prefixCls", "className", "loading", "checkLabel", "unCheckLabel", "size", "defaultValue", "value", "color", "readOnly", "disabled", "onBeforeChange", "onChange", "onClick"]);
        const iconStyle = { fontSize: `${size / 1.5}rem` };
        const innerStyle = { width: `${size}rem`, height: `${size}rem` };
        const switchStyle = { width: `${size * 2}rem`, height: `${size * 1.1}rem` };
        return (<div {...resetProps} style={Object.assign({ backgroundColor: color }, switchStyle)} className={cls(prefixCls, className, { [`${prefixCls}-off`]: !checked, 'x-disabled': disabled || this.state.loading })} onClick={(e) => this.handleClick(e)}>
        <span style={innerStyle} className={cls(`${prefixCls}-inner`)}>
          {this.state.loading
            ? <Icon style={iconStyle} spin className="x-icon-loading"/>
            : <i style={iconStyle} className="x-icon">&nbsp;</i>}
        </span>
        <span style={iconStyle} className={`${prefixCls}-innerText`}>{checked ? checkLabel : unCheckLabel}</span>
      </div>);
    }
    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (prevProps.value !== this.props.value && this.props.value !== prevState.value) {
            this.setState({ value: this.props.value });
        }
        return null;
    }
    get value() {
        return this.state.value;
    }
    handleClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const value = !this.state.value;
            const { disabled, readOnly, onClick, onBeforeChange, onChange, loading } = this.props;
            // 进入等待
            if (loading && !this.state.loading)
                this.setState({ loading: true });
            // 完成等待
            if (disabled || readOnly || onBeforeChange && (yield onBeforeChange(value)) === false) {
                return this.setState({ loading: false });
            }
            this.setState({ value, loading: false }, () => {
                onClick && onClick(e, this);
                onChange && onChange(value);
            });
        });
    }
}
Switch.defaultProps = {
    prefixCls: 'x-switch',
    size: 1.5,
    color: '#4dd865',
    loading: false,
    disabled: false,
    readOnly: false,
    checkLabel: '',
    unCheckLabel: '',
    defaultValue: false
};
